/**
 *
 * Icon - this is different from DynamicReactIcon because this does not compile the React Icons and cause JS bloat reducing google pagespeed score
 *
 */

import React from 'react';
import { SBackground } from './styles';
// import StarIcon from
// import SuccessIcon from
// import FacebookIcon from
// import InstagramIcon from
// import WhatsappIcon from
// import YoutubeIcon from
// import LinkedinIcon from
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const iconMap = {
  star: 'images/svg/star.svg',
  success: 'images/svg/success.svg',
  whatsapp: 'images/svg/whatsapp.svg',
  facebook: 'images/svg/facebook.svg',
  instagram: 'images/svg/instagram.svg',
  linkedin: 'images/svg/linkedin.svg',
  youtube: 'images/svg/youtube.svg',
};
import { isBrowser } from 'utils/auth';

const getIcon = variant => {
  let icon;

  const path1 = `images/svg/${variant}.svg`;
  const path2 = iconMap[variant];

  // console.log(`path1=${path1}, path2=${path2}, equal=${path1 === path2}`);
  // console.log('Icon = ' + iconMap[variant]);
  // const LocalIcon = loadable(() => import('images/svg/linkedin.svg'));

  const LocalIcon = loadable(() => import(`images/svg/${variant}.svg`));
  icon = isBrowser && <LocalIcon alt={`Oasis Living ${variant}`} />;
  return icon;
};

const Icon = ({
  width,
  height,
  iconVariant,
  withBackground,
  fill,
  isIconFill,
}) => {
  return (
    <SBackground
      iconWidth={width}
      iconHeight={height}
      withBackground={withBackground}
      fill={fill}
      color={fill}
      shouldFill={isIconFill}
      className="header-icon" // for signalling to other parts of code for css in container
    >
      {getIcon(iconVariant)}
    </SBackground>
  );
};

Icon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  iconVariant: PropTypes.string,
  fill: PropTypes.string,
  withBackground: PropTypes.bool,
  isIconFill: PropTypes.bool,
};

export default Icon;
